import spartaStoreUtility from "utilities/global/sparta-store-utility/3.1.2/js/sparta-store-utility";
import spartaValidationFramework from "utilities/global/sparta-validation-framework/7.2.3/js/sparta-validation-framework";
import currentWidgetDetails from "utilities/platform/widget-details";
















const utilityNamespace = 'ahSafepassCommonsUtility';






 const EVENTS = {};
 let deliveryType = "";

export default class AhSafepassCommonsUtility {
  constructor(options) {
        this.$ = options.$;
        this._ = options._;
        this.cawCommons = options.cawCommons;
        this.cawEventsMaster = options.cawEventsMaster;
        this.constructorParams = options.constructorParams;
        this.parentModule = options.context;
        this.spartaUILayersUtility = options.spartaUILayersUtility;
        this.spartaMessageUtil = options.spartaMessageUtil;
        this.spartaValidationFramework = options.spartaValidationFramework;
        this.jsEncrypt = options.jsEncrypt;
        this.Handlebars = options.hb;
        this.parentModule.ahCawTransportUtility = options.ahCawTransportUtility;
        this.parentModule.clientParams = this.constructorParams.clientParams;
        const basePath = this.cawCommons.getBasePath(this.parentModule.spaParams);
        this.parentModule["apiEndPoints"] = this.cawCommons.getEndPoints(this.constructorParams.apiEndPoints, basePath);
        window.jQuery = this.$;
  }











  defineVars(){
        const self = this;
        const spModule = this.parentModule;
        const $ = this.$;
        spModule.templates = {};

        spModule.$moduleContext = $(spModule.view.settings.target);

          spModule.EVENTS = {
              OTP_REQUEST_CANCEL: "AH_UNIVERSAL_SP_REQUEST_CANCEL",
			  SP_VALIDATE_CODE_FAILURE: "AH_UNIVERSAL_SP_VALIDATE_CODE_FAILURE"
          };

          const elementsID = {
              'main-container': 'SP-Container',
              errorTarget: 'ah-sp-container-error-target'
          };

          const elementsClass = {};


          this.elementsSelectors = {};

          $.each(elementsID, (i, val) => {
              this.elementsSelectors[i] = `#${val}`;
          });
          $.each(elementsClass, (i, val) => {
              this.elementsSelectors[i] = `.${val}`;
          });


        return this;
  }

  bindEventHandlers($jContext){
	  const self = this;
	  const spModule = this.parentModule;
	  const $ = this.$;

	  if (!$jContext) {
          $jContext = self.getContext();
      }

	  $jContext.find("#request-continue").off("click").on("click", () => {
		  self.initiateSafepass();
	  });

      $jContext
      .find("#request-cancel")
      .off("click.publishcancelsp")
      .on("click.publishcancelsp", e => {
          self.publishEvent("AH_CAW_CANCEL");
         $('#spRequest').addClass('hidden');
      });

	  	$jContext.find("#start-again").off("click").on("click", () => {
			$('#spEnterCard').addClass('hidden');
			$('#spRequest').removeClass('hidden');
			self.hideAllErrors();
		});


	  const moduleContext = spModule.$moduleContext;
        const inputSettings = {
            validate: true
        };

        moduleContext.spartaInputs(inputSettings);


        const oFormValidations = {};
        const sValidationDataAttr = "data-validation-rules";
        $jContext.find(`[${sValidationDataAttr}]`).each(function() {
            const $this = $(this);
            oFormValidations[$this.attr("id")] = $this.data("validation-rules");
            $this.removeAttr(sValidationDataAttr);
        });
        self.spartaValidationFramework.fn.core.bindValidationRules(oFormValidations, true);

        return self;

  }

  _bindEnterScreenHandler($jContext){
      const self = this;
	  const spModule = this.parentModule;
	  const $ = this.$;
      if (!$jContext) {
          $jContext = self.getContext();
      }

      $jContext.find("#request-continue").off("click").on("click", () => {
		  self.initiateSafepass();
	  });

	  	$jContext.find("#continue-enter").off("click").on("click", () => {
			let isValid = self.validateFields("enterSp");
			if(isValid) {
				self.validateSafepass();
			}
		});












        $jContext.find("#safePassPhoneCode").off("keyup").on("keyup", (e) => {
            let codeval = $('#safePassPhoneCode').val();
			let isValid = /^\d+$/.test(codeval);
             let keyVal = e.which || e.keyCode;
            if(keyVal !== 13){
                if($('#safePassPhoneCode').val().length === 6 && isValid) {
                $("#continue-enter").removeClass('spa-btn--disabled');
                $("#continue-enter").addClass('spa-btn--primary');
                }

                if($('#safePassPhoneCode').val().length < 6||!isValid){
                    $("#continue-enter").removeClass('spa-btn--primary');
                    $("#continue-enter").addClass('spa-btn--disabled');
                }
            }else{
                let isformValid = self.validateFields("enterSp");
                if(isformValid) {
                    self.validateSafepass();
                }
            }
		});

        $jContext.find("#safePassCardCode").off("keyup").on("keyup", (e) => {
			let codeval = $('#safePassCardCode').val();
            let isValid = /^\d+$/.test(codeval);
            let keyVal = e.which || e.keyCode;
            if(keyVal !== 13){
                if($('#safePassCardCode').val().length == 6 && isValid ) {
                    $("#continue-enter").removeClass('spa-btn--disabled');
                    $("#continue-enter").addClass('spa-btn--primary');
                }
                if($('#safePassCardCode').val().length < 6||!isValid){
                    $("#continue-enter").removeClass('spa-btn--primary');
                    $("#continue-enter").addClass('spa-btn--disabled');
                }
            }else{
                let isformValid = self.validateFields("enterSp");
                if(isformValid) {
                    self.validateSafepass();
                }
            }

		});


	  $jContext.find("#cancel-enter").off("click").on("click", () => {
		self.publishEvent("AH_CAW_CANCEL");
        $('#spEnterCard').addClass('hidden');
	  });

	  $jContext.find("#start-again-card, #start-again-phone").off("click").on("click", () => {
		$('#spEnterCard').addClass('hidden');
	 	$('#spRequest').removeClass('hidden');
		self.hideAllErrors();
	  });

	  const moduleContext = spModule.$moduleContext;
        const inputSettings = {
            validate: true
        };

        moduleContext.spartaInputs(inputSettings);


        const oFormValidations = {};
        const sValidationDataAttr = "data-validation-rules";
        $jContext.find(`[${sValidationDataAttr}]`).each(function() {
            const $this = $(this);
            oFormValidations[$this.attr("id")] = $this.data("validation-rules");
            $this.removeAttr(sValidationDataAttr);
        });
        self.spartaValidationFramework.fn.core.bindValidationRules(oFormValidations, true);

        return self;
  }

  subscribeEvents(){
    const $ = this.$;
    const me = this;
	const spModule = this.parentModule;
    this.parentModule.Events.sub("AH_SAFEPASS_CHALLENGE_INIT",function(e){
      $('#SP-Container').removeClass('hidden');
      me.initiateStepup(e);
    });


    this.parentModule.Events.sub("AH_SIGNIN_FIRST_FACTOR_INITIALIZE",function(e){
         $('#SP-Container').addClass('hidden');
         me.hideAllErrors();
    });


    this.parentModule.Events.sub("SP_SUCCESS",function(e){
		$('#SP-Container').addClass('hidden');
		me.hideAllErrors();
    });

    return this;
  }

  getUrl(urlCode) {
    const spModule = this.parentModule;

    const host = spModule.Store.getData('widgetConfigData');
    if (!host.domain) {
      return spModule.apiEndPoints[urlCode];
    } else {
      let endpoint = this.cawCommons.getEndPoints(this.constructorParams.apiEndPoints, host.domain);
      return endpoint[urlCode];
    }
  }

  initiateStepup(e){
    const self = this;
        const spModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        if(e){
            self.sucessData = e.data;
        }
        const deferred = $.Deferred();
		let stepUpUrl = '';
	if(spModule.clientParams.origin === "SBOB"){
		stepUpUrl = this.getUrl('sbStepUpUrl');
	}
	else{
		stepUpUrl = this.getUrl('stepUpUrl');
	}
    let requestPayload = this._getDefaultParams('stepup');



    const ajaxOptions = {
      method: 'POST',
      data: JSON.stringify(requestPayload),
      url: stepUpUrl,
      crossDomain: true,
      cache: false,
      timeout: 60000,
      processData: false,
      xhrFields: {
          withCredentials: true,
      },
      headers: {
          'content-type': 'application/json',
          clientAIT: '41339',
          accept: 'application/json',
          'cache-control': 'no-cache',
      },
      dataType: 'json',
  };
  const initiateCall = spModule.ahCawTransportUtility;
  initiateCall._serviceCall(ajaxOptions, (response) => {
      if(response.responseData.errorInfo && response.responseData.errorInfo.length > 0 && response.responseData.errorInfo[0].code){
        self._handleCommonUtilError(response.responseData.errorInfo[0].code);
      }else{
        self._prepareContacts(response.responseData);
      }
  },function(error){
  });
}

  initiateSafepass(){
	    const self = this;
        const spModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const deferred = $.Deferred();
		    self.hideAllErrors();


        const host = spModule.Store.getData('widgetConfigData');
        let sendCodeUrl = this.getUrl('generateSafepassUrl');
        let requestPayload = this._getDefaultParams('sendCode');
        let $selectedValue = $("input[name='contact']:checked");
        requestPayload.securedContactPoint.encryptedContactPoint.value = $("input[name='contact']:checked").val();
        requestPayload.securedContactPoint.maskedContactPoint.value = $('label[for='+$selectedValue.attr('id')+']').text();
        requestPayload.securedContactPoint.deliveryMethod=_.result(_.find(self.contactList, function(obj) {
             return obj.encryptedContactPoint.value === requestPayload.securedContactPoint.encryptedContactPoint.value;
        }), 'deliveryMethod');
		deliveryType = requestPayload.securedContactPoint.deliveryMethod;
        if(requestPayload.securedContactPoint.deliveryMethod === "TEXT"){
            self.isSafePassCard = false;
            self.selectedPhone = requestPayload.securedContactPoint.maskedContactPoint.value;

            const ajaxOptions = {
                method: 'POST',
                data: JSON.stringify(requestPayload),
                url: sendCodeUrl,
                crossDomain: true,
                cache: false,
                timeout: 60000,
                processData: false,
                xhrFields: {
                    withCredentials: true,
                },
                headers: {
                    'content-type': 'application/json',
                    clientAIT: '41339',
                    accept: 'application/json',
                    'cache-control': 'no-cache',
                },
                dataType: 'json',
            };
            const initiateCall = spModule.ahCawTransportUtility;
            initiateCall._serviceCall(ajaxOptions, (response) => {
                if(response.responseData && _.get(response.responseData, "completion.code")  === "SUCCESS"){

                    if(!self.isSafePassCard){
                        let contactData = new Object();
                        contactData.phoneNumber = self.selectedPhone;
                        $('#spEnterCard').html(spModule.templates.enterSp(contactData));
                        $('#spEnterCard').removeClass('hidden');
                        $('.enter-sp-card').addClass('hidden');
                        $('.enter-sp-phone').removeClass('hidden');
                        $('#spRequest').addClass('hidden');
                    }
                    self._bindEnterScreenHandler(self.getContext());
                }else if(response.responseData.errorInfo){
                    if(response.responseData.errorInfo.length > 0 && response.responseData.errorInfo[0].code){
                    	if(response.responseData.errorInfo[0].code === "INVALID_SESSION"){
							self._handleCommonUtilError("INVALID-SESSION");
						}
						else{
							self._handleCommonUtilError(response.responseData.errorInfo[0].code);
						}
                    }
                }
            },function(jqXHR, textStatus, errorThrown) {
                if (200 !== jqXHR.status) {
                    self._handleError("GENERAL_ERROR");
                }
                self._clearfields();
            });
        }else{
            self.isSafePassCard = true;
            let contactData = new Object();
            contactData.phoneNumber = "";
            $('#spEnterCard').html(spModule.templates.enterSp(contactData));
            $('#spEnterCard').removeClass('hidden');
            $('.enter-sp-card').removeClass('hidden');
            $('.enter-sp-phone').addClass('hidden');
            $('#spRequest').addClass('hidden');
			self._bindEnterScreenHandler(self.getContext());
        }
	}

  _clearfields() {
      $("input[type=text]").val("");
  }

  _handleCommonUtilError(errorCode){
     const self = this;
     const spModule = this.parentModule;
     const $ = this.$;
     const _ = this._;
     const defaultConfig = {
         '$moduleContext': $(spModule.settings.target),
         'basePath': self.cawCommons.getBasePath(spModule.spaParams),
         'mainContainer': '#sp-body',
         'messageUtility': self.spartaMessageUtil,
         'errorTarget': '#ah-sp-container-error-target',
         'size':'medium'
     }
     return self.cawCommons.handleError(spModule.errorCodeJCR.error,
         Object.assign({}, defaultConfig, { 'errorCode': errorCode }));
 }

  validateSafepass(){
        const self = this;
        const spModule = this.parentModule;
        const $ = this.$;
        const _ = this._;
        const deferred = $.Deferred();
		let $jContext = self.getContext();
		self.hideAllErrors();
        let validateCodeUrl = this.getUrl('validateSafepassUrl');
	      let requestPayload = this._getDefaultParams('validateCode');
        if(self.isSafePassCard){
            requestPayload.authenticationCode = $('#safePassCardCode').val();
            requestPayload.processRules[2].value = "SAFEPASS_CARD";
        }else{
            requestPayload.processRules[2].value = "SAFEPASS_MOBILE";
            requestPayload.authenticationCode = $('#safePassPhoneCode').val();
        }

	  const ajaxOptions = {
	      method: 'POST',
	      data: JSON.stringify(requestPayload),
	      url: validateCodeUrl,
	      crossDomain: true,
	      cache: false,
	      timeout: 60000,
	      processData: false,
	      xhrFields: {
	          withCredentials: true,
	      },
	      headers: {
	          'content-type': 'application/json',
	          clientAIT: '41339',
	          accept: 'application/json',
	          'cache-control': 'no-cache',
	      },
	      dataType: 'json',
	  };
	  const initiateCall = spModule.ahCawTransportUtility;
	  initiateCall._serviceCall(ajaxOptions, (response) => {
			if(response.responseData && _.get(response.responseData, "completion.code")  === "SUCCESS"){				
				if(spModule.clientParams.origin === "SBOB"){
					self.publishEvent("SBOB_SP_SUCCESS", response.responseData);
				}
				else{
					let spValidateCodeSuccess = self.cawEventsMaster.EVENTS.SP_SUCCESS;
					self.publishEvent(spValidateCodeSuccess,self.sucessData);
				}
			}else if(response.responseData.errorInfo){
				if(response.responseData.errorInfo.length > 0 && response.responseData.errorInfo[0].code){
					let spValidateCodeFailure = spModule.EVENTS.SP_VALIDATE_CODE_FAILURE;
					self.publishEvent(spValidateCodeFailure);
					if(response.responseData.errorInfo[0].code === "INVALID_SESSION"){
						self._handleCommonUtilError("INVALID-SESSION");
					}
					else{
						self._handleCommonUtilError(response.responseData.errorInfo[0].code);
					}
				}
            }
	  },function(error){

		  let spValidateCodeFailure = spModule.EVENTS.SP_VALIDATE_CODE_FAILURE;
		  self.publishEvent(spValidateCodeFailure);
          self._handleCommonUtilError(error.errorInfo[0].code);
	  });
	}

  getContext() {
      const self = this;
      const spModule = this.parentModule;
      const $ = this.$;
      return spModule.$moduleContext;
  }

  _prepareContacts(responseData){
     const self = this;
     const spModule = this.parentModule;
     const $ = this.$;
     const _ = this._;
     const $jContext = self.getContext();
     let isCardOnly = false;

     if(!spModule.CACHED){
        spModule.CACHED = {};
        spModule.CACHED._WidgetContainerRoot = spModule.$moduleContext.find("#SP-Container");
        spModule.CACHED._SPRequestInitialDom = spModule.CACHED._WidgetContainerRoot.find("#sp-body").clone();
     }else{
         $("#sp-content").html(spModule.CACHED._SPRequestInitialDom.clone());
     }


     let contactList = responseData.stepUpSecuredContactPoints;
     self.contactList = contactList;

     if(contactList){
        let phoneList = [];
        let cardList = [];
            contactList.forEach(function(data,index){
            if(data.deliveryMethod === "SAFEPASS_CARD"){
                let element ={};
                element.inputName = 'contact';
                element.id = 'contact' + index;
                element.value = data.encryptedContactPoint.value;
                element.label = data.maskedContactPoint.value;
                cardList.push(element);
            }else if(data.deliveryMethod === "TEXT"){
                let element ={};
                element.inputName = 'contact';
                element.id = 'contact' + index;
                element.value = data.encryptedContactPoint.value;
                element.label = data.maskedContactPoint.value;
                phoneList.push(element);
            }
        },this);
        if(phoneList.length === 0 && cardList.length >= 1) {
            	isCardOnly = true;
        }
        let contactInfo = new Object();
        contactInfo.cardList = cardList;
        contactInfo.phoneList = phoneList;
        contactInfo.cardList.isCardOnly = isCardOnly;
        $('#spRequest').html(spModule.templates.spcontacts(contactInfo));
     }else{
    	 self._handleCommonUtilError("NO-CONTACTS");
     }
     self.bindEventHandlers(self.getContext());
  }

   _getDefaultParams(urlCode) {
        const spModule = this.parentModule;
        if (urlCode === "validateCode") {

            return {
                authenticationCode: "TO-BE-FILLED",
                processRules: [{
                        name: "SourceChannel",
                        value: "OLB"
                    },
                    {
                        name: "AuthenticationContext",
                        value: spModule.clientParams.pageID
                    },
                    {
                        name: "type",
                        value: "TO-BE-FILLED"
                    }
                ]
            };

        } else if (urlCode === "stepup") {

			if(spModule.clientParams.origin === "SBOB"){
				return {				
					"processRules":[{"name":"AuthenticationContext","value":"sbusrsafepass"}],
					"stepUpToken":{"stepUpType":"SAFEPASS"}
				};
			}
			else{
				return {				

					authenticationLevel: { code: "targetAuthLevel", value: "400" },
					processRules: [{ name: "AuthenticationContext", value: spModule.clientParams.pageID }],
					stepUpToken:{stepUpType:"SAFEPASS"}
				};					

							}

        } else if (urlCode === "sendCode") {

            return {
                securedContactPoint: {
                    maskedContactPoint: {
                        value: "TO-BE-FILLED",
                        description: "Masked Phone Number"
                    },
                    encryptedContactPoint: {
                        algorithm: "RSA",
                        value: "TO-BE-FILLED"
                    },
                    deliveryMethod: "TO-BE-FILLED",
                    priority: "high",
                    authenticationType: "SAFEPASS"
                },
                processRules: [{
                        name: "SourceChannel",
                        value: "VMA"
                    },
                    {
                        name: "AuthenticationContext",
                        value: "SGNONSFCHLNG"
                    }
                ]
            };
        }
    }

	validateFields(screenName) {
        const self = this;
        const spModule = this.parentModule.view;
        const $ = this.$;
        const _ = this._;

        const $jContext = $(spModule.settings.target);

        let validationSuccess = true;
        let errorCode = "";
        let invalidInputFields = []; 


        self.hideAllErrors();
        const inputSettings = {
                validate: true,
            };
        $jContext.spartaInputs(inputSettings);
        $jContext.find("[data-validation]:visible").each(function() {

            if (validationSuccess) {
            	const $currentElement = $(this);
                let elemVal = $(this).val();
                const dataValidation = $(this).attr("data-validation");
                const validationRules = $.parseJSON($(this).attr("data-validation"));
                _.forOwn(validationRules, function(value, key) {

                    if (validationSuccess) {
                        if (key === "empty") {
                            if (_.trim(elemVal).length === 0) {
                                errorCode = value;
                                validationSuccess = false;
                                invalidInputFields.push($currentElement);
                            }
                        } else if(key === "numeric-only") {
                            if (!/^\d+$/.test(elemVal)) {
                                errorCode = value;
                                validationSuccess = false;
                                invalidInputFields.push($currentElement);
                            }
                        } else if(key === "length"){
							if(!/^.{6}$/.test(elemVal)){
								errorCode = value;
                                validationSuccess = false;
                                invalidInputFields.push($currentElement);
							}
						}
                        else {}

                    }
                });
            }
        });
        return validationSuccess;
    }

    hideAllErrors() {
        let $jContext = this.getContext();
        const $ = this.$;

        $jContext.find("#ah-sp-container-error-target").empty();


        $jContext.find("[data-validation]:visible").each(function() {
            $(this).removeClass('spa-error-form-input--validation');
            $(this).siblings('label').removeClass('spa-error-form-label--validation');
            $(this).siblings('div.spa-input-error-message').text("");
        });
    }

  getNSAwareEvent(eventName) {
      if(this.parentModule["events-namespace"]){
        return eventName + this.parentModule["events-namespace"];
      }else{
          return eventName;
      }
  }

  publishEvent(eventName, data) {
       const eventToPublish = this.getNSAwareEvent(eventName);
       this.parentModule._debug(`Publishing Event: ${eventToPublish}`);
       this.parentModule.Events.pub(eventToPublish, data);
  }

  bindThisContext(methods, context, suffix = 'Scoped') {
      const self = context;
      if (methods && $.isArray(methods) && methods.length > 0) {
          $(methods).each((index, method) => {
              if (self[method]) {
                  self[method + suffix] = self[method].bind(context);
              } else {

              }
          });
      }
      return this;
  }

  compileAllTemplates() {
        const self = this;
        const spModule = this.parentModule;
        const $ = this.$;

        let allTemplates = spModule.$moduleContext.find('template[type="text/x-handlebars-template"]');

        allTemplates.each(function() {
            spModule.templates[$(this).attr("template-name")] = self.Handlebars.compile(
                $(this)
                .html()
                .replace(/\[\[/g, "{{")
                .replace(/\[\[\[/g, "{{{")
                .replace(/\]\]/g, "}}")
                .replace(/\]\]\]/g, "}}}")
            );
        });
        return self;
    }
}
